module.exports = __webpack_public_path__ + "static/media/telephone.c23e8f94.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Components/Nav-Home/telephone.svg
// module id = 27
// module chunks = 1